__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cartRoot";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "19.2.15", () => (Promise.all([__webpack_require__.e(3942), __webpack_require__.e(1965), __webpack_require__.e(5480), __webpack_require__.e(615)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 5480))))));
			register("@angular/common", "19.2.15", () => (Promise.all([__webpack_require__.e(3942), __webpack_require__.e(1823), __webpack_require__.e(615), __webpack_require__.e(819)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 1823))))));
			register("@angular/core/primitives/di", "19.2.15", () => (__webpack_require__.e(3126).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives/di.mjs */ 3126))))));
			register("@angular/core/primitives/signals", "19.2.15", () => (Promise.all([__webpack_require__.e(9719), __webpack_require__.e(9090)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives/signals.mjs */ 9090))))));
			register("@angular/core", "19.2.15", () => (Promise.all([__webpack_require__.e(3942), __webpack_require__.e(9719), __webpack_require__.e(2567), __webpack_require__.e(3073)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 2567))))));
			register("@angular/router", "19.2.15", () => (Promise.all([__webpack_require__.e(3942), __webpack_require__.e(1965), __webpack_require__.e(3776), __webpack_require__.e(9779), __webpack_require__.e(615), __webpack_require__.e(7833), __webpack_require__.e(4649), __webpack_require__.e(5797)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 9779))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};